import imgs from './../img/set/*.JPG';
export const AMOUNT_OF_IMAGES = Object.keys(imgs).length;

export const SPEED = {
    value: 0.5,
    min: 0.1,
    max: 180,
    step: 0.1,
};

export const AMOUNT = {
    value: 20,
    min: 10,
    max: AMOUNT_OF_IMAGES - 1,
    step: 1,
};

export const EXAM = {
    value: 5,
    min: 1,
    max: AMOUNT.value,
    step: 1,
};
